import { Type } from '@angular/core';
import { Column, InputType } from '@miq/catalog';
import { AbstractAdvancedInput } from './abstract-advanced-input';
import { AdvancedCheckboxInputComponent } from './checkbox-input/advanced-checkbox-input.component';
import {
  AdvancedChipsInputComponent,
  AdvancedStrictChipsInputComponent,
} from './chips-input/advanced-chips-input.component';
import { AdvancedDateInputComponent } from './date-input/advanced-date-input.component';
import { AdvancedNaicsInputComponent } from './naics-input/advanced-naics-input.component';
import { AdvancedNumberInputComponent } from './number-input/advanced-number-input.component';
import { AdvancedSelectInputComponent } from './select-input/advanced-select-input.component';
import { AdvancedTextAreaInputComponent } from './text-area-input/text-area-input.component';
import { AdvancedTextInputComponent } from './text-input/text-input.component';
import { AdvancedYearInputComponent } from './year-input/advanced-year-input.component';

export const InputTypeToAdvancedInputMap: Map<InputType, Type<AbstractAdvancedInput>> = new Map<
  InputType,
  Type<AbstractAdvancedInput>
>([
  [InputType.Dropdown, AdvancedSelectInputComponent],
  [InputType.Number, AdvancedNumberInputComponent],
  [InputType.Text, AdvancedTextInputComponent],
  [InputType.TextArea, AdvancedTextAreaInputComponent],
  [InputType.Checkbox, AdvancedCheckboxInputComponent],
  [InputType.Chips, AdvancedChipsInputComponent],
  [InputType.StrictChips, AdvancedStrictChipsInputComponent],
  [InputType.Date, AdvancedDateInputComponent],
  [InputType.NAICS, AdvancedNaicsInputComponent],
  [InputType.Year, AdvancedYearInputComponent],
]);

export interface InputConfig extends Pick<
  Column,
  | 'dataType'
  | 'inputType'
  | 'tooltip'
  | 'placeholder'
  | 'type'
  | 'required'
  | 'isDisabled'
  | 'options'
  | 'values'
  | 'max'
  | 'min'
  | 'allowNegatives'
  | 'valueSetter'
  | 'minDate'
  | 'alwaysEmitChanges'
> {
  readonly?: boolean;
  inputType: InputType;
}
